import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';


const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();

  return (
    <>
      <MetaControlField
        attr={'moduleName'}
        {...dataAttrs('risk-tolerance-title', resource, {
          [testAttr.dataType]: resource.attr('type'),
        })}
      />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={2}>
          <MetaControlField attr={'subtitle'} />
          <MetaControlField attr={'primaryText'} />
          <MetaControlField attr={'secondaryText'} />
          <MetaControlField attr={'options'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        {resource.meta().canPost()
          ? <FDPrimaryActionButton
            label={'Continue →'}
            loading={saving}
            onClick={() => {
              onSubmit();
            }}
            {...dataAttrs('continue-btn', resource, {
              [testAttr.dataType]: resource.attr('type'),
            })}
          /> : null}
      </DialogActions>
    </>
  );
};

export default Layout;
